if (!process || !process.env) {
    throw new Error(
        'process.env is required, please make sure you are using npm scripts and have a .env file in root'
    );
}

export default {
    env: process.env.REACT_APP_ENV,
    api: {
        host: process.env.REACT_APP_API_HOST
    },
    auth0Config: {
        domain: process.env.REACT_APP_AUTH0_DOMAIN,
        clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
        redirectUri: `${process.env.REACT_APP_UI_HOST}/callback`,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        responseType: 'token id_token',
        scope: 'openid profile email'
    }
};


// WEBPACK FOOTER //
// ./src/config.js